export const USER_LOCAL_STORAGE = {
  CURRENT_USER: 'redtrack_admin_cu',
  HEADERS_USER_TOKENS: 'redtrack_admin_hut',
  THEME: 'redtrack_admin_ut',
};

export const ACCOUNT_TYPES = {
  0: 'Affiliate',
  1: 'Advert',
  2: 'Agency',
};

export const GLOBAL_EXPORT_BUTTON_ENABLED = [
  'vz@redtrack.io',
  'e.potser@redtrack.io',
  'admin@local.host',
  'a.riedkin@redtrack.io',
  's.murashka@redtrack.io',
  'kateryna.andreiko@redtrack.io',
  'tatsiana.lukashevich@redtrack.io',
];
